const runtimeConfig = typeof window !== 'undefined' ? window.__APP_CONFIG__ || {} : {};

const readValue = (key, fallback = '') => {
    const runtimeValue = runtimeConfig[key];
    if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
        return runtimeValue;
    }

    const buildValue = process.env[key];
    if (buildValue !== undefined && buildValue !== null && buildValue !== '') {
        return buildValue;
    }

    return fallback;
};

const APP_ENV = Object.freeze({
    BACKEND_API_URL: readValue('REACT_APP_PHARO_CONSUMER_BACKEND_API_URL'),
    CLIENT_SHORT_NAME: readValue('REACT_APP_PHARO_CONSUMER_CLIENT_SHORT_NAME'),
    CLIENT_NAME: readValue('REACT_APP_PHARO_CONSUMER_CLIENT_NAME'),
    CLIENT_ID: readValue('REACT_APP_PHARO_CONSUMER_CLIENT_ID'),
    CLIENT_RETURN_URL: readValue('REACT_APP_PHARO_CONSUMER_CLIENT_RETURN_URL'),
    APP_INSIGHT_CONNECTION_STRING: readValue('REACT_APP_APP_INSIGHT_CONNECTION_STRING')
});

export default APP_ENV;
